import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  app: {
    backgroundColor: theme.palette.background.main,
    padding: '30px 0 0 0',
  },
  contentWrapper: {
    padding: '0 40px',
  },
  search: {
    position: 'relative',
    borderRadius: 5,
    marginLeft: 0,
    width: 250,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  searchIcon: {
    padding: '0 5px',
    height: 'auto',
    position: 'absolute',
    pointerEvents: 'none',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#707070',
    top: 'calc(50% - 8px)',
    left: 0,
    '& svg': {
      fontSize: '22px',
    },
  },
  inputRoot: {
    color: 'inherit',
    backgroundColor: 'transparent',
    border: '1px solid #C1C1BF',
    borderRadius: 4,
    paddingRight: '10px !important',
    fontSize: 12,
    paddingBottom: 0,
    paddingLeft: 30,
    '& input': {
      fontSize: 16,
    },
  },
  inputField: {
    marginTop: 0,
    '& .MuiInputLabel-root': {
      paddingLeft: 30,
      fontFamily: 'Source Sans Pro, sans-serif',
    },
    '& .Mui-focused': {
      color: '#5C5C5C',
    },
    '& .MuiInputLabel-shrink': {
      paddingLeft: '0 !important',
    },
    '& .MuiInput-underline:after': {
      borderBottom: 'none !important',
    },
    '& .MuiInput-underline:before': {
      borderBottom: 'none !important',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottom: 'none !important',
    },
    '& .MuiInput-underline:focus:not(.Mui-disabled):before': {
      borderBottom: 'none !important',
    },
    '& .MuiAutocomplete-inputRoot[class*="MuiInput-root"] .MuiAutocomplete-input:first-child': {
      padding: '6px 0 6px 0',
    },
    '& .MuiAutocomplete-clearIndicator': {
      backgroundColor: '#CF1F3890',
      color: '#FFFFFF',
      top: 3,
      marginRight: 0,
      '&:hover': {
        backgroundColor: '#CF1F38',
      },
    },
    '& .MuiAutocomplete-popupIndicator': {
      marginRight: 0,
    },
    '& .MuiSvgIcon-root': {
      width: '0.65em',
      height: '0.65em',
    },
    '& .MuiInputBase-adornedStart': {
      border: '1px solid #28a745 !important',
      '& .MuiAutocomplete-clearIndicator': {
        visibility: 'visible !important',
      },
    },
  },
  selectedSpan: {
    marginRight: 8,
    color: '#28a745',
    cursor: 'default',
    maxWidth: 155,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  popperOptions: {
    '& li': {
      padding: 0,
      margin: 0,
    },
  },
  option: {
    fontSize: 14,
    padding: '6px 8px !important',
    margin: '0 !important',
    width: '100%',
  },
  selected: {
    backgroundColor: '#28a745 !important',
    color: '#FFFFFF !important',
  },
}));

export default useStyles;
